/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DocumentOcrSnapshotRequestViewModel } from "../types/DocumentOcrSnapshotRequestViewModel.ts";

export const documentOcrSnapshotRequestViewModelSchema = z.object({
  courseRegistrationIds: z
    .array(z.number().int())
    .describe(
      "IDs das matrículas cujos documentos serão analisados; duplicados são ignorados.",
    )
    .nullish(),
}) as unknown as ToZod<DocumentOcrSnapshotRequestViewModel>;
